import React from 'react';

export default class ActionsMenu extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		return (
			<div className="ActionsMenu">
				<span>
					<i className="fas fa-pencil-alt mx-2"/>
					<i className="fas fa-trash mx-2" />
				</span>
			</div>
		);
	}
}
